import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { ClientInfo } from 'src/app/core/models/accessToken';
import { AuthService } from 'src/app/core/services/auth.service';
import { JwtService } from 'src/app/core/services/jwt.service';
import { LogoService } from 'src/app/core/services/logo.service'; import { DialogFiltersService } from '../../documentos-clientes/components/filters/dialog-filters/service/dialog-filters.service';
import { BusquedaDocumentos } from '../../documentos-clientes/components/models/BusquedaDocumentos';
import { ClienteRelacionDocumentosCliente } from '../../documentos-clientes/components/models/ClienteRelacionDocumentosCliente';
import { TipoDocFiltro } from '../../documentos-clientes/components/models/TipoDocFiltro';
import { TipoDocumentoClientes } from '../../documentos-clientes/components/models/TipoDocumentoClientes';
import { DocumentosClienteService } from '../../documentos-clientes/components/services/documentos-cliente.service';
import { TableDataService } from '../../documentos-clientes/components/services/table-data.service';
import { Documento } from './modelos/Documento';
import { Proveedor } from './modelos/proveedor';
import { UltimoDoc } from './modelos/ultimoDoc';
import { AccesosDirectosHomeService } from './servicios/accesos-directos-home.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogFakeDoorButtonMailComponent } from '../dialog-fake-door-button-mail/dialog-fake-door-button-mail.component';
import { ConfigurationServicesService } from 'src/app/core/services/configuration-services.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsEventsService } from 'src/app/core/services/google-analytics-events.service';


const MAX_PROVEEDORES = 8;

@Component({
  selector: 'app-accesos-directos-pp',
  templateUrl: './accesos-directos-pp.component.html',
  styleUrls: ['./accesos-directos-pp.component.scss']
})
export class AccesosDirectosPpComponent implements OnInit {

  mostrarProveedores = false;
  empresaActual: ClientInfo | null;

  ultimosDocs: any[];
  mostrarUltimosDocs = false;
  grupos: any;

  // ordenar por fecha ultimo doc
  proveedores: Proveedor[] = []
  
  arrowsVisible = false;
  slideConfig = {
    "slidesToShow": 10,
    "slidesToScroll": 1,
    "infinite": false,
    "arrows": true,
    "draggable": false,
    "responsive": [
      {
        breakpoint: 1780,
        settings: {
          slidesToShow: 9,
        }
      },
      {
        breakpoint: 1610,
        settings: {
          slidesToShow: 8,
        }
      },
      {
        breakpoint: 1420,
        settings: {
          slidesToShow: 7,
        }
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 1078,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 710,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };
  proveedoresConfig = {
    "slidesToShow": 8,
    "slidesToScroll": 1,
    "infinite": false,
    "arrows": true,
    "draggable": false,
    "responsive": [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor(private logoService: LogoService,
    private ADService: AccesosDirectosHomeService,
    private jwtService: JwtService,
    private service: DocumentosClienteService,
    private authService: AuthService,
    private dialogFiltersService: DialogFiltersService,
    private tableDataSourceService: TableDataService,
    private router: Router,
    private dialog: MatDialog,
    private servicioConfigurationServices: ConfigurationServicesService,
    private translate: TranslateService,
    private el: ElementRef,
    private cookieService: CookieService,
    private googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    // private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.empresaActual = this.setEmpresa();

    this.ADService.getUltimosDocs(this.empresaActual?.Id!, this.empresaActual?.IdPais!).subscribe(ultimosDocs => {
      this.ultimosDocs = ultimosDocs.sort((a: any, b: any) => this.translate.instant(a.resourceKeyGrupo??'').localeCompare(this.translate.instant(b.resourceKeyGrupo??'')));
      
      if (this.ultimosDocs.length > 0) {
        this.mostrarUltimosDocs = true;
      }
    })

    this.ADService.getGrupos().subscribe(grupos => {
      let result = grupos.reduce(function (r: any, grupo: any) {
        r[grupo.tipoGrupo] = r[grupo.tipoGrupo] || [];
        r[grupo.tipoGrupo].push(new Documento(grupo.idTipoDocumento, grupo.tipoDocumento));
        return r;
      }, Object.create(null));
      this.grupos = result;
    })

    this.ADService.getPortalDeProveedores(this.empresaActual?.Id!, this.empresaActual?.IdPais!).subscribe(proveedores => {
      this.proveedores = proveedores;
      if (this.proveedores.length > 0) {
        this.mostrarProveedores = true;
      }
      this.proveedores = this.shuffleAndPickProveedores(this.proveedores);
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.validateArrowsVisibility();
    }, 0);
  }

  setEmpresa(): ClientInfo | null {
    return this.jwtService.getAccessToken()?.userdata?.Cliente ?? null;
  }

  agregarTimeZone(): string {
    return this.authService.getTimeZone();
  }

  shuffleAndPickProveedores(arrayProveedores: Proveedor[]) {
    const shuffledArray = arrayProveedores.sort((a, b) => 0.5 - Math.random());
    return shuffledArray;
  }

  setearFechassessionStorage(filtrosessionStorage: BusquedaDocumentos): void {
    filtrosessionStorage.fechaDesde = moment(filtrosessionStorage.fechaDesde).isValid() ? moment(filtrosessionStorage.fechaDesde) : null;
    filtrosessionStorage.fechaHasta = moment(filtrosessionStorage.fechaHasta).isValid() ? moment(filtrosessionStorage.fechaHasta) : null;
    filtrosessionStorage.fechaVencimientoDesde = moment(filtrosessionStorage.fechaVencimientoDesde).isValid() ? moment(filtrosessionStorage.fechaVencimientoDesde) : null;
    filtrosessionStorage.fechaVencimientoHasta = moment(filtrosessionStorage.fechaVencimientoHasta).isValid() ? moment(filtrosessionStorage.fechaVencimientoHasta) : null;
    filtrosessionStorage.fechaEmisionDesde = moment(filtrosessionStorage.fechaEmisionDesde).isValid() ? moment(filtrosessionStorage.fechaEmisionDesde) : null;
    filtrosessionStorage.fechaEmisionHasta = moment(filtrosessionStorage.fechaEmisionHasta).isValid() ? moment(filtrosessionStorage.fechaEmisionHasta) : null;
    filtrosessionStorage.fechaEntregaDesde = moment(filtrosessionStorage.fechaEntregaDesde).isValid() ? moment(filtrosessionStorage.fechaEntregaDesde) : null;
    filtrosessionStorage.fechaEntregaHasta = moment(filtrosessionStorage.fechaEntregaHasta).isValid() ? moment(filtrosessionStorage.fechaEntregaHasta) : null;
  }

  onGrupoClick(event: any, doc: UltimoDoc) {
    if (doc.resourceKeyGrupo === "facturasIncompletas") {
      const busqueda = new BusquedaDocumentos();
      busqueda.estadosDocumentos.push(doc.idEstadoDocumento);
      busqueda.criterioFiltroFecha = "ULTIMOS_90_DIAS";
      busqueda.rangoFecha = 90;
      this.setearFechassessionStorage(busqueda);
      this.tableDataSourceService.setSearchFilters(busqueda);
      this.router.navigate([
        '/main/documentos/37',
      ]);
      return;
    }
    this.ADService.getFiltroHome("90DHOME").pipe(take(1)).subscribe((data: BusquedaDocumentos) => {
      this.dialogFiltersService.getTiposDocumentosPorClientes([this.authService.getOwner()]).subscribe((tiposDocumentosClientes: TipoDocumentoClientes[]) => {
        let documentosFiltrados: TipoDocumentoClientes[] = this.filterDuplicados(tiposDocumentosClientes);
        const sentido = this.resolverSentido(doc.sentido.toUpperCase());

        if (this.grupos[doc.resourceKeyGrupo]) {
          this.grupos[doc.resourceKeyGrupo].forEach((documento: any) => {
            if (documentosFiltrados.find((docFiltrado: TipoDocumentoClientes) => docFiltrado.idTipoDocumento === documento.id && docFiltrado.sentido === sentido)) {
              
              if(this.validarPorTipoDocYSentido(documento, sentido)){
                let documetoGrupo: TipoDocFiltro = { id: documento.id, resourceKey: documento.resourceKey, sentido: sentido }
                data.tiposDocumentos.push(documetoGrupo);
              }
            }
          });
        }
        else {
          let documetoGrupo: TipoDocFiltro = { id: doc.documento.id, resourceKey: doc.documento.resourceKey!, sentido: sentido }
          data.tiposDocumentos.push(documetoGrupo);
        }
        this.setearFechassessionStorage(data);
        this.tableDataSourceService.setSearchFilters(data);
      });
    })

    this.router.navigate([
      '/main/documentos/37',
    ]);
  }
  resolverSentido(sentido: string): string {
    if (sentido === 'ENVIADAS' || sentido === 'ENVIADOS' || sentido === 'ENVIADO' || sentido === 'ENVIADA') {
      return 'ENVIADO';
    } else {
      return 'RECIBIDO';
    }
  }

  filterDuplicados(res: TipoDocumentoClientes[]): TipoDocumentoClientes[] {
    let tiposDocumento: TipoDocumentoClientes[] = [];
    res.forEach(element => {
      let encontrado = false;
      tiposDocumento.forEach(element2 => {
        if (element.resourceKeyTipoDocumento === element2.resourceKeyTipoDocumento && element.esDeEmision === element2.esDeEmision) {
          encontrado = true;
        }
      });
      if (!encontrado) {
        tiposDocumento.push(element);
      }
    });
    return tiposDocumento;
  }

  validarPorTipoDocYSentido(documento: any, sentido: string): boolean {
    return documento.resourceKey !== 'ReporteConciPrecios' || sentido === 'RECIBIDO';
  }

  onProveedorClick(event: any, proveedor: any) {
    this.ADService.getFiltroHome("90DHOME").pipe(take(1)).subscribe((data: BusquedaDocumentos) => {
      let interlocutor: ClienteRelacionDocumentosCliente = { id: proveedor.id, idPais: proveedor.idPais };
      data.interlocutores.push(interlocutor);
      this.setearFechassessionStorage(data);
      this.tableDataSourceService.setSearchFilters(data);
    })

    this.router.navigate([
      '/main/documentos/37',
    ]);
  }

  async onSeguimientoEntregaClick() {
    
    this.googleAnalyticsEventsService.emitEvent('AccesoDirecto', 'Seguimiento de Entregas', this.empresaActual?.RazonSocial, 1);
    const userClientdata = this.authService.userdata.Cliente;
    const tieneServicio = await this.servicioConfigurationServices.ValidarClienteTieneServicioContratado(userClientdata.Id, userClientdata.IdPais,'SeguiEntregas');
    if(tieneServicio){ 
      this.authService.generarBasicTokenJWT('SeguimientoEntregas').subscribe((token: any) => {
        this.cookieService.set('token', token,{ path: '/', secure:true,sameSite: "Strict", domain: environment.dominioSeguimientoEntrega}); // agregar domain para pruebas locales domain: 'krikos360lab.planexware.com'
      
        window.location.href = environment.urlSeguimientoEntrega;
      });
    }
    else{
          this.dialog.open(DialogFakeDoorButtonMailComponent,
            {
              data: {
                title: 'FAKE_DOOR_BUTTON.SEGUIMIENTO_DE_ENTREGAS_TITLE',
                text: 'FAKE_DOOR_BUTTON.SEGUIMIENTO_DE_ENTREGAS_DESC',
                imgName:'IMG_BLURRED_SEGUIMIENTO_ENTREGA.png',
                imgWidth: '58%',
                funcionalidad: 'Entregas IA'
              },
              autoFocus: false,
              maxHeight: '95vh',
              panelClass: 'fake-door-dialog-container' 
            }
          );
    }
  }

  async OnClickGestionarTurnosDeEntrega(){
    this.googleAnalyticsEventsService.emitEvent('AccesoDirecto', 'Gestion de Turnos', this.empresaActual?.RazonSocial, 1);
    const userClientdata = this.authService.userdata.Cliente;
    const tieneServicio = await this.servicioConfigurationServices.ValidarClienteTieneServicioContratado(userClientdata.Id, userClientdata.IdPais,'EmMaestroSponsors');
    if(tieneServicio){
      this.authService.generarBasicTokenJWT('GestionTurnos').subscribe((token: any) => {
        this.cookieService.set('token', token,{ path: '/', secure:true,sameSite: "Strict", domain: environment.dominioGestionTurnos});
      
        window.location.href = environment.urlGestionTurnos;
      });
    }
    else{
          this.dialog.open(DialogFakeDoorButtonMailComponent,
            {
              data: {
                title: 'FAKE_DOOR_BUTTON.GESTION_DE_TURNO_DE_ENTREGAS_TITLE',
                text: 'FAKE_DOOR_BUTTON.GESTION_DE_TURNO_DE_ENTREGAS_DESC',
                imgName:'IMG_GESTION_DE_TURNOS.png',
                imgWidth: '100%',
                funcionalidad: 'Gestión de Turnos de Entrega'
              },
              autoFocus: false,
              maxHeight: '95vh',
              panelClass: 'fake-door-dialog-container' 
            }
          );
    }
  }

  onAfterCarouselChange(event: any): void {
    this.arrowsVisible = event.slick.$prevArrow.is(':visible') || event.slick.$nextArrow.is(':visible');
  }

  validateArrowsVisibility(): void {
    const slickElement = this.el.nativeElement.querySelector('.slick-wrapper');
    if (slickElement) {
      const prevArrow = slickElement.querySelector('.slick-prev');
      const nextArrow = slickElement.querySelector('.slick-next');
      this.arrowsVisible = (prevArrow && prevArrow.style.display !== 'none') || (nextArrow && nextArrow.style.display !== 'none');
      
    }
  }

}
